import { api, config } from '../../../helpers/api';
import { generatePath } from 'react-router-dom';

export async function getSurveyRequest(id) {
  return await api.get(generatePath('/survey/:id', { id }), config('json'));
}

export async function surveyResponseRequest({ survey_id }) {
  return await api.post(
    '/survey_response/',
    {
      survey_id
    },
    config('json')
  );
}

export async function getSurveyQuestionsRequest(survey_id, survey_response_id) {
  return await api.get(
    '/survey_question/',
    config('json', { survey_id, survey_response_id })
  );
}

export async function surveyAnswerRequest({
  answer,
  survey_response_id,
  survey_question_id,
  selected_option_ids
}) {
  return await api.post(
    '/survey_answer/',
    {
      answer,
      survey_response_id,
      survey_question_id,
      selected_option_ids
    },
    config('json')
  );
}

export async function surveySubmitRequest(id) {
  return await api.post(
    generatePath('/survey_response/:id', { id }),
    {},
    config('json')
  );
}
